import * as Yup from 'yup';
import checkoutFormModel from './formModel';
import moment from "moment";
import {CardNumberValidator} from "../../../../FormikUtils/CardNumberValidator";
import {isValidPhoneNumber} from "react-phone-number-input";

const {
    formField: {
        tamanioVivienda,
        tipoVivienda,
        codigosLocalidad,
        vigenciaDesde,
        formaDePago,
        infoDePago: {
            numeroCbu,
            marcaTarjeta,
            numeroTarjeta,
        },
        rol,
        dni,
        personaJuridica,
        cuit,
        nombre,
        apellido,
        fechaNacimiento,
        estadoCivil,
        sexo,
        domicilio,
        telefono,
        email,
        situacionIva,
        categoriaMonotributo,
        actividadPrincipal,
        lugarNacimiento,
        detalleEquipoElectronico: {
            sumaAseguradaElectronico,
            descripcionElectronico,
        },
        detalleBicicletas: {
            sumaAseguradaBicicletas,
            descripcionBicicletas,
        },
        detalleMonopatines: {
            sumaAseguradaMonopatines,
            descripcionMonopatines,
        },
    }
} = checkoutFormModel;
let tipoTarjeta;
let equipoElectronicoSelected = false;
let bicicletasSelected = false;
let monopatinesSelected = false;
const fecha45dias = moment(moment().format('YYYY-MM-DD'), "YYYY-MM-DD").add(45, 'days')

function formatDate(date) {
    return new Date(date).toLocaleDateString()
}

export default [
    Yup.object().shape({
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`)
            .test('codigoLocalidad', "Seleccione una localidad válida",
                (value) => {
                    if (value) return value.includes(",")
                    else return false
                }),
        [tipoVivienda.name]: Yup.string().required(`${tipoVivienda.requiredErrorMsg}`),
        [tamanioVivienda.name]: Yup.string().required(`${tamanioVivienda.requiredErrorMsg}`),
        [dni.name]: Yup.number()
            .required(`${dni.requiredErrorMsg}`)
            .min(1000000, "El documento ingresado no es válido")
            .max(99999999, "El documento ingresado no es válido")
            .integer()
            .typeError("Introduzca únicamente números"),
        [nombre.name]: Yup.string()
            .required(`${nombre.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [apellido.name]: Yup.string()
            .required(`${apellido.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
            .max(40, "El apellido ingresado es muy largo"),
        [telefono.name]: Yup.string()
            .test('telefono', "El celular ingresado no es válido",
                (value) => {
                    if (typeof value === "string")
                        return (isValidPhoneNumber(value))
                    else return false
                }
            ),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
    }),
    Yup.object().shape({
        coberturas: Yup.object().test('product-selection', 'Debe seleccionar al menos un producto', coberturas => {
            let isThereAnySelected = false;
            for (let cob in coberturas) {
                if (coberturas[cob].selectedCobertura === true) {
                    isThereAnySelected = true;
                }
            }
            return isThereAnySelected
        })
    }),
    Yup.object().shape({}),
    Yup.object().shape({
        [nombre.name]: Yup.string()
            .required(`${nombre.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [apellido.name]: Yup.string()
            .required(`${apellido.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
            .max(40, "El apellido ingresado es muy largo"),
        [telefono.name]: Yup.string()
            .test('telefono', "El celular ingresado no es válido",
                (value) => {
                    if (typeof value === "string")
                        return (isValidPhoneNumber(value))
                    else return false
                }
            ),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
        [rol.name]: Yup.string().required(`${rol.requiredErrorMsg}`),
        [dni.name]: Yup.number()
            .required(`${dni.requiredErrorMsg}`)
            .min(1000000, "El documento ingresado no es válido")
            .max(99999999, "El documento ingresado no es válido")
            .integer()
            .typeError("Introduzca únicamente números"),
        [cuit.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string()
                .required(`${cuit.requiredErrorMsg}`)
                .matches(/^(20|23|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/, "El CUIT ingresado no es válido"),
        }),
        [fechaNacimiento.name]: Yup.date().when([personaJuridica.name], {
            is: '0',
            then: Yup.date()
                .max(new Date(Date.now() - 567648000000), "El cliente debe tener al menos 18 años para contratar")
                .required(`${fechaNacimiento.requiredErrorMsg}`),
        }),
        [estadoCivil.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string().required(`${estadoCivil.requiredErrorMsg}`),
        }),
        [sexo.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string().required(`${sexo.requiredErrorMsg}`),
        }),
        [domicilio.name]: Yup.string()
            .required(`${domicilio.requiredErrorMsg}`)
            .matches(/^[A-Za-z0-9 .-]+$/, "Esta utilizando carácteres no válidos"),
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`)
            .test('codigoLocalidad', "Seleccione una localidad válida",
                (value) => {
                    if (value) return value.includes(",")
                    else return false
                }),
        [situacionIva.name]: Yup.string().required(`${situacionIva.requiredErrorMsg}`),
        [categoriaMonotributo.name]: Yup.string().required(`${categoriaMonotributo.requiredErrorMsg}`),
        [actividadPrincipal.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string().required(`${actividadPrincipal.requiredErrorMsg}`),
        }),
        [lugarNacimiento.name]: Yup.string().when([personaJuridica.name], {
            is: '0',
            then: Yup.string()
                .required(`${lugarNacimiento.requiredErrorMsg}`)
                .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
        }),
    }),
    Yup.object().shape({
        [vigenciaDesde.name]: Yup.date()
            .required(`${vigenciaDesde.requiredErrorMsg}`)
            .min(moment().format('YYYY-MM-DD'), "La fecha no puede ser anterior al dia de hoy")
            .max(fecha45dias, `La fecha no puede ser posterior a ${formatDate(fecha45dias)}`),

        [formaDePago.name]: Yup.string().required(`${formaDePago.requiredErrorMsg}`),
        infoDePago: Yup.object().when([formaDePago.name], {
            is: '4',    // Débito por CBU
            then: Yup.object().shape({
                [numeroCbu.name]: Yup.string()
                    .required(`${numeroCbu.requiredErrorMsg}`)
                    .matches(/^[0-9]+$/, "Ingrese un número válido")
                    .min(22, 'El número de CBU debe tener 22 dígitos')
                    .max(22, 'El número de CBU debe tener 22 dígitos'),
            })
        }).when([formaDePago.name], {
            is: '2',    // Tarjeta de crédito
            then: Yup.object().shape({
                [marcaTarjeta.name]: Yup.string().test('cardType', 'Seleccione un tipo de tarjeta', type => {
                    tipoTarjeta = type;
                    if (tipoTarjeta !== null) return true;
                }).required(`${marcaTarjeta.requiredErrorMsg}`),
                [numeroTarjeta.name]: Yup
                    .string()
                    .test('cardNumber',
                        'El número de tarjeta ingresado es inválido', //validation message
                        value => {
                            if (tipoTarjeta === "9") {
                                if (value !== undefined && value.length === 15)
                                    return CardNumberValidator(tipoTarjeta, value)
                            } else {
                                if (value !== undefined && value.length === 16)
                                    return CardNumberValidator(tipoTarjeta, value)
                            }
                        })
                    .required()
            })
        }),
    }),
    Yup.object().shape({
        //DummyValue for trigger callback method
        dummyValue: Yup.string(),
        detalleBicicletas: Yup.array().of(
            Yup.object().shape({
                [sumaAseguradaBicicletas.name]: Yup.number()
                    .integer()
                    .typeError("Introduzca únicamente números")
                    .when("dummyValue", {
                        is: () => {
                            return bicicletasSelected === true
                        },
                        then: Yup.number()
                            .required(`${sumaAseguradaBicicletas.requiredErrorMsg}`)
                            .typeError("Introduzca únicamente números")
                            .test('notZeroInsuredSum', "La suma debe ser superior a cero", (value) => value > 0)
                    }),
                [descripcionBicicletas.name]: Yup.string()
                    .matches(/^[A-Za-z0-9 ,-]+$/, "Ingrese una descripción válida")
                    .when("dummyValue", {
                        is: () => {
                            return bicicletasSelected === true
                        },
                        then: Yup.string().required(`${descripcionBicicletas.requiredErrorMsg}`)
                    }),
            })).test('insuredSumsAgreggationBicicletas', "Las sumas declaradas deben coincidir con las aseguradas", (sumas, context) => {
                const coberturasAd = context.parent.coberturas;
                let sumaAsegurada = 0;
                bicicletasSelected = false

                //MICRO
                for (let cobertura in coberturasAd) {
                    if (cobertura === '48' && coberturasAd[cobertura].selectedCobertura) {
                        bicicletasSelected = true
                        sumaAsegurada = coberturasAd[cobertura].sumaAsegurada
                    }
                }

                let totalInsuredValue = 0;
                sumas.map((item) => {
                    if (item.sumaAseguradaBicicletas !== undefined)
                        totalInsuredValue += item.sumaAseguradaBicicletas;
                })

                return (sumaAsegurada === totalInsuredValue)
            }
        ),
        detalleMonopatines: Yup.array().of(
            Yup.object().shape({
                [sumaAseguradaMonopatines.name]: Yup.number()
                    .integer()
                    .typeError("Introduzca únicamente números")
                    .when("dummyValue", {
                        is: () => {
                            return monopatinesSelected === true
                        },
                        then: Yup.number()
                            .required(`${sumaAseguradaMonopatines.requiredErrorMsg}`)
                            .typeError("Introduzca únicamente números")
                            .test('notZeroInsuredSum', "La suma debe ser superior a cero", (value) => value > 0)
                    }),
                [descripcionMonopatines.name]: Yup.string()
                    .matches(/^[A-Za-z0-9 ,-]+$/, "Ingrese una descripción válida")
                    .when("dummyValue", {
                        is: () => {
                            return monopatinesSelected === true
                        },
                        then: Yup.string().required(`${descripcionMonopatines.requiredErrorMsg}`)
                    }),
            })).test('insuredSumsAgreggationMonopatines', "Las sumas declaradas deben coincidir con las aseguradas", (sumas, context) => {
                const coberturasAd = context.parent.coberturas;
                let sumaAsegurada = 0;
                monopatinesSelected = false

                //MICRO
                for (let cobertura in coberturasAd) {
                    if (cobertura === '49' && coberturasAd[cobertura].selectedCobertura) {
                        monopatinesSelected = true
                        sumaAsegurada = coberturasAd[cobertura].sumaAsegurada
                    }
                }

                let totalInsuredValue = 0;
                sumas.map((item) => {
                    if (item.sumaAseguradaMonopatines !== undefined)
                        totalInsuredValue += item.sumaAseguradaMonopatines;
                })

                return (sumaAsegurada === totalInsuredValue)
            }
        ),
        detalleEquipoElectronico: Yup.array().of(
            Yup.object().shape({
                [sumaAseguradaElectronico.name]: Yup.number()
                    .integer()
                    .typeError("Introduzca únicamente números")
                    .when("dummyValue", {
                        is: () => {
                            return equipoElectronicoSelected === true
                        },
                        then: Yup.number()
                            .required(`${sumaAseguradaElectronico.requiredErrorMsg}`)
                            .typeError("Introduzca únicamente números")
                            .test('notZeroInsuredSum', "La suma debe ser superior a cero", (value) => value > 0)
                    }),
                [descripcionElectronico.name]: Yup.string()
                    .matches(/^[A-Za-z0-9 ,-]+$/, "Ingrese una descripción válida")
                    .when("dummyValue", {
                        is: () => {
                            return equipoElectronicoSelected === true
                        },
                        then: Yup.string().required(`${descripcionElectronico.requiredErrorMsg}`)
                    }),
            })).test('insuredSumsAgreggationElectrónicos', "Las sumas declaradas deben coincidir con las aseguradas", (sumas, context) => {
                const coberturasAd = context.parent.coberturas;
                let sumaAsegurada = 0;
                equipoElectronicoSelected = false

                //MICRO
                for (let cobertura in coberturasAd) {
                    if (cobertura === '26' && coberturasAd[cobertura].selectedCobertura) {
                        equipoElectronicoSelected = true
                        sumaAsegurada = coberturasAd[cobertura].sumaAsegurada
                    }
                }

                let totalInsuredValue = 0;
                sumas.map((item) => {
                    if (item.sumaAseguradaElectronico !== undefined)
                        totalInsuredValue += item.sumaAseguradaElectronico;
                })

                return (sumaAsegurada === totalInsuredValue)
            }
        ),
    }),
];
